import i18n from 'i18next';
import React from 'react';
import {Button, FormGroup, FormLabel, Modal} from 'react-bootstrap';
import {FaArrowRight} from 'react-icons/fa';
import {SwEmbeddedDetail, SwExitButton, SwForm} from 'simplifyworks-core-ui';

function NotificationOrMessagePreviewModal({ show, closeModalFn, confirmModalFn, data, isMessage }) {
	return <>
		<Modal
			show={show}
			backdrop='static'
			onHide={closeModalFn}
			size='xl'
		>
			<Modal.Header closeButton>
				<Modal.Title
					style={{ width: 'auto' }}
				>
					{isMessage ? i18n.t('foedus-message-previewTitle') : i18n.t('foedus-notification-previewTitle')}
				</Modal.Title>
			</Modal.Header>

			<Modal.Body className='modal-remove-footer'>

				<SwEmbeddedDetail
					name={'user-notification-email-preview'}
					rest={'/fake-rest-placeholder'}
					restId={'new'}
					tabName={''}
					hideButtons
					disabled
				>
					<SwForm
						name={'create-user-notification-email-preview'}
						rest={''}
						labelKeyPrefix={'foedus-notification'}
						initialValue={data}
					>
						<SwForm.Section>
							<SwForm.Custom
								property='recipientEmails'
								size={12}
								render={(resource) => {
									return (
										<FormGroup>
											<FormLabel>{i18n.t('foedus-notification-recipients')}</FormLabel>
											<div>{resource?.recipientEmails?.join(', ')}</div>
										</FormGroup>
									);
								}}
							/>

							<SwForm.Custom
								property='bccEmails'
								size={12}
								hidden={!data?.bccEmails}
								render={(resource) => {
									return (
										<FormGroup>
											<FormLabel>{i18n.t('oodUsNotif-bccs')}</FormLabel>
											<div>{resource?.bccEmails?.join(', ')}</div>
										</FormGroup>
									);
								}}
							/>

							<SwForm.String
								property='subject'
								labelKey='foedus-notification-subject'
								size={12}
							/>

							<SwForm.Html size={12} property='body' />
						</SwForm.Section>
					</SwForm>
				</SwEmbeddedDetail>

			</Modal.Body>

			<Modal.Footer>
				<SwExitButton onClick={closeModalFn} />
				<Button
					variant='primary'
					onClick={confirmModalFn}
				>
					<FaArrowRight />{' ' + i18n.t('foedus-notification-createBtn')}
				</Button>
			</Modal.Footer>
		</Modal>
	</>;
}

export default NotificationOrMessagePreviewModal;
